import React from 'react'

const AdminSchedullingOrderEditComponent = () => {
  return (
    <>
        <div>AdminSchedullingOrderEditComponent</div>
    </>
  )
}
export default AdminSchedullingOrderEditComponent